const ServiceProxyConfig = {
  Market: {
    MarketInDepth: {
      ServiceUrl: `${
        process.env.REACT_APP_MARKET_SERVICE_ENDPOINT
      }/MarketInDepth/`,
    },
    HeatMap: {
      ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/HeatMap/`,
    },
    Fundamental: {
      ServiceUrl: `${
        process.env.REACT_APP_MARKET_SERVICE_ENDPOINT
      }/api/Fundamental`,
    },
    WatchList: {
      ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/WatchList/`,
    },
    MarketCalendar: {
      ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/Calendar/`,
    },
    MoneyFlow: {
      ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/MoneyFlow/`,
    },
    Chart: {
      ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/Chart/`,
    },
  },
  Prices: {
    PriceDepthUrl: `${
      process.env.REACT_APP_PRICE_SERVICE_ENDPOINT
    }/PriceDepth/`,
    PriceDataUrl: `${process.env.REACT_APP_PRICE_SERVICE_ENDPOINT}/PriceData/`,
    TimeAndSaleUrl: `${
      process.env.REACT_APP_PRICE_SERVICE_ENDPOINT
    }/TimeAndSales/`,
  },
  TopMover: {
    ServiceUrl: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/TopMover/`,
    ServiceChart: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/Chart/`,
    ServiceDownload: `${
      process.env.REACT_APP_MARKET_SERVICE_ENDPOINT
    }/Download/`,
  },
  Technical: {
    Charting: `${process.env.REACT_APP_PRICE_SERVICE_ENDPOINT}/TradingView/`,
    Deceptive: `${
      process.env.REACT_APP_PRICE_SERVICE_ENDPOINT
    }/TechnicalAnalysisSignals/`,
  },

  Fundamental: {
    FinancialStatement: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/FinancialStatement/`,
    },
    FinancialAnalysis: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/FinancialAnalysis/`,
    },
    OwnerShip: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/Ownership/`,
    },
    CashDividendAnalysis: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/CashDividendAnalysis/`,
    },
    Snapshot: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/Snapshot/`,
    },
    ConsensusAnalysis: {
      ServiceUrl: `${
        process.env.REACT_APP_FUNDAMENTAL_SERVICE_ENDPOINT
      }/ConsensusAnalysis/`,
    },
  },
  Tools: {
    Alerts: {
      ServiceUrl: `${process.env.REACT_APP_TOOL_SERVICE_ENDPOINT}/`,
      ServiceChart: `${process.env.REACT_APP_MARKET_SERVICE_ENDPOINT}/Chart/`,
    },
    Screener: {
      ServiceUrl: `${process.env.REACT_APP_TOOL_SERVICE_ENDPOINT}/Screener/`,
    },
    Valuation: {
      ServiceUrl: `${process.env.REACT_APP_TOOL_SERVICE_ENDPOINT}/Valuation/`,
    },
  },
  Common: {
    Master: {
      ServiceUrl: `${process.env.REACT_APP_COMMON_SERVICE_ENDPOINT}/Master/`,
    },
    UserSetting: {
      ServiceUrl: `${
        process.env.REACT_APP_COMMON_SERVICE_ENDPOINT
      }/UserSetting/`,
    },
  },
  News: {
    ServiceUrl: `${process.env.REACT_APP_NEWS_SERVICE_ENDPOINT}/News/`,
  },
  Stategy: {
    Ranking: {
      ServiceUrl: `${
        process.env.REACT_APP_STRATEGY_SERVICE_ENDPOINT
      }/Rankings/`,
    },
    Strategy: {
      ServiceUrl: `${
        process.env.REACT_APP_STRATEGY_SERVICE_ENDPOINT
      }/Strategy/`,
    },
  },
  TAStategy: {
    ServiceUrl: `${
      process.env.REACT_APP_STRATEGY_SERVICE_ENDPOINT
    }/TAStrategy/`,
  },
};
export default ServiceProxyConfig;
